var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToolAndPaper(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mit_bl._Kreislinie",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{clip-path:url(#clippath-2);}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8{fill:none;}.cls-9{fill:#fff;}.cls-2,.cls-3,.cls-5{stroke-linecap:round;stroke-linejoin:round;}.cls-2,.cls-5,.cls-8{stroke:#009fe3;}.cls-10{fill:#009fe3;}.cls-3{stroke:#fff;stroke-width:2px;}.cls-5{stroke-width:.51px;}.cls-6{clip-path:url(#clippath);}.cls-7{clip-path:url(#clippath-1);}.cls-8{stroke-width:3px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    width: 150,
    height: 150
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 5,
    y: 5,
    width: 140,
    height: 140
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 5,
    y: 5,
    width: 140,
    height: 140
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Messschieber_mit_Dokument"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 75,
    cy: 75,
    r: 68.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m91.54,72.43h-14.22c-.42,0-.77.35-.77.78v30.43c0,.43.34.78.77.78h21.72c.42,0,.77-.35.77-.78v-22.87l-8.27-8.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m91.54,72.43h-14.22c-.42,0-.77.35-.77.78v30.43c0,.43.34.78.77.78h21.72c.42,0,.77-.35.77-.78v-22.87l-8.27-8.33Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m88.27,78.47h-7.89m8.22,3.32h-8.22m14.04,3.32h-14.04m14.04,3.32h-14.04m14.04,3.32h-14.04m14.04,3.32h-14.04m14.04,3.32h-14.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "91.65 80.37 91.65 72.76 99.66 80.37 91.65 80.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "91.65 80.37 91.65 72.76 99.66 80.37 91.65 80.37"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m55.74,48.79v-3.57h9.66l13.37,5.45.03.75h-13.41s-.19,7.33-.19,7.33h-2.6s-1.3.19-1.3,1.69v11.19s.37,1.79,1.58,1.79h2.32v31.6h-9.57v-31.6h2.51s1.49-.38,1.49-1.88v-11.1s-.37-1.69-1.49-1.69h-2.41v-5.83h-5.39s-.19-4.14,3.16-4.14h2.23Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "62.99 71.54 67.63 71.54 67.63 66.09 78.91 60.45 62.99 60.45 62.99 71.54"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m57.97,71.64v-11.28h-7.24s-.19,2.16,1.11,3.29c1.3,1.13,2.6,1.13,2.6,1.13v6.87h3.53Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolAndPaper);
export default __webpack_public_path__ + "static/media/tool-and-paper.0e9025c4f032580257d24d8fb3ac5022.svg";
export { ForwardRef as ReactComponent };